export const BASE_URL = "https://www.api.marketing.serconsrus.ru";